import { useLocation } from "@remix-run/react";
import { AppSidebar } from "~/components/app-sidebar";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "~/components/ui/sidebar";
import type { AuthenticatedUser } from "~/models/auth";
import { Separator } from "~/components/ui/separator";
// import VerticalBanner from "~/components/advertisements/VerticalBanner";

interface SideBarProps {
  children: React.ReactNode;
  user: AuthenticatedUser | null;
}

export default function SideBar({ children, user }: SideBarProps) {
  const location = useLocation();

  if (
    location.pathname.includes("login") ||
    location.pathname.includes("signup")
  ) {
    return <>{children}</>;
  }

  return (
    <SidebarProvider>
      <AppSidebar user={user} />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            {/*<Breadcrumb>*/}
            {/*    <BreadcrumbList>*/}
            {/*        <BreadcrumbItem className="hidden md:block">*/}
            {/*            <BreadcrumbLink href="#">*/}
            {/*                Building Your Application*/}
            {/*            </BreadcrumbLink>*/}
            {/*        </BreadcrumbItem>*/}
            {/*        <BreadcrumbSeparator className="hidden md:block" />*/}
            {/*        <BreadcrumbItem>*/}
            {/*            <BreadcrumbPage>Data Fetching</BreadcrumbPage>*/}
            {/*        </BreadcrumbItem>*/}
            {/*    </BreadcrumbList>*/}
            {/*</Breadcrumb>*/}
          </div>
        </header>
        <div className={"grid h-full w-full grid-cols-12"}>
          {/* <VerticalBanner /> */}
          <div className={"col-span-12 mx-auto w-full px-4 sm:col-span-12"}>
            {children}
          </div>
          {/* <VerticalBanner /> */}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
